'use es6';

export const canSpamAsString = ({
  companyName,
  companyStreetAddress_1: companyStreetAddress,
  companyStreetAddress_2: companyStreetAddress2,
  companyCity,
  companyState,
  companyZip,
  companyCountry,
  companyPhone
}, language) => {
  companyStreetAddress2 = companyStreetAddress2 || '';
  companyZip = companyZip || '';
  companyCountry = companyCountry || '';
  companyPhone = companyPhone || '';
  const canSpamSettingsOrdered = language === 'ja' ? [companyName, [companyCountry, companyZip].join(''), [companyState, companyCity, companyStreetAddress2, companyStreetAddress].join(''), companyPhone] : [companyName, companyStreetAddress, companyStreetAddress2, companyCity, `${companyState} ${companyZip}`, companyCountry, companyPhone];
  return canSpamSettingsOrdered.filter(val => !!val).join(language === 'ja' ? ' ' : ', ').trim();
};